"use client";

import { getMerchantProfile } from "@services/safebuy-users/merchant-service";
import { MerchantProfile } from "@interfaces/safebuy-users";
import { useState, useEffect } from "react";

export function useMerchantProfile(merchantId: string | null) {
  const [merchantProfile, setMerchantProfile] =
    useState<MerchantProfile | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (merchantId) {
      setLoading(true);
      setError(null);

      getMerchantProfile(merchantId)
        .then((res) => {
          setMerchantProfile(res);
          setLoading(false);
        })
        .catch((err) => {
          console.error("CATCH MERCHANT PROFILE ERROR : ", err);
          setError(err.message || "Failed to fetch merchant profile");
          setLoading(false);
        });
    } else {
      setMerchantProfile(null);
      setLoading(false);
      setError(null);
    }
  }, [merchantId]);

  return { merchantProfile, loading, error };
}

export async function fetchMerchantProfile(
  merchantId: string
): Promise<MerchantProfile | null> {
  if (!merchantId) {
    return null;
  }

  try {
    const data = await getMerchantProfile(merchantId);
    return data;
  } catch (error) {
    console.error("CATCH MERCHANT PROFILE DATA ERROR : ", error);
    return null;
  }
}
